/* eslint-disable react-hooks/rules-of-hooks */
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Stack from "@mui/material/Stack";
import Send from "@mui/icons-material/Send";
import Mic from "@mui/icons-material/Mic";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import audio from "../../../app/assets/audio-wave.gif";
import { gtag, install } from "ga-gtag";
import iconClosed from "../../assets/iconBotDrowsy.png";
import iconOpen from "../../assets/iconBotFocused.png";
import iconAI from "../../assets/iconBotThinking.png";
import iconLoading from "../../assets/iconBotNotes.png";
import iconQuantum from "../../assets/iconBotQuantum.png";
import iconError from "../../assets/iconBotDizzy.png";
import iconAutopilotStill from "../../assets/iconAutopilotThinking.png";
import iconAutopilotWriting from "../../assets/iconAutopilotFocused.png";
import iconGlitch from "../../assets/iconBotGlitchy.png"
import {
  useRef,
  useState,
  useEffect,
  ChangeEvent,
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  ReactPortal,
} from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  Button,
  MuiThemeProvider,
  createTheme,
  withStyles,
} from "@material-ui/core";
import Collapse from "@mui/material/Collapse";
import Person from "@mui/icons-material/Person";
import Close from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import myLoader from "../../assets/loader.gif";
import "./ChatWidget.css";

install("G-LBY0B19H81");

const ttl = 21600;
let timeToReset = -1;
let dfMessenger = document.getElementById("dfMessenger");
let chatId = dfMessenger?.getAttribute("session-id");
if (chatId) {
  window.sessionStorage.setItem("chatId", chatId);
}
const theme = createTheme({
  palette: {
    primary: {
      main: "#458AEB",
    },
    secondary: {
      main: "#FFFFFF",
    },
  },
});

const responseBadRequest =
  "Something goes wrong with your request. Could you repeat your instruction?";

const useStyles = makeStyles({
  table: {
    minWidth: 500,
  },
  chatSection: {
    width: "100%",
  },
  headBG: {
    backgroundColor: "#e0e0e0",
  },
  borderRight500: {
    borderRight: "1px solid #e0e0e0",
  },
  messageArea: {
    height: "40vh",
    overflowY: "auto",
    backgroundColor: "#FAFAFA",
  },
});

const initialList: any[] = [
  {
    type: "text",
    content: [`Say "Hi" to start a new chat with me, or click the button below to help me squash some bugs!`],
    justify: "flex-start",
    visibility: "visible",
  },
  {
    type: "button_link",
    content: [`Play Bug Invasion`],
    justify: "flex-start",
    link: "https://testreactwebglunity.web.app/",
    visibility: "visible",
  },
];

interface State {
  textFieldValue: string;
}

const ChatWidget = (props: {
  display: any;
  bottom: any;
  right: any;
  zIndex: any;
  pointerEvents: any;
  opacity: any;
  setShowAutoPilot: Function;
  setStartAutoPilot: Function;
  startAutoPilot: boolean;
}) => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [showResume, setShowResume] = useState(false);
  const [isAutopilotActive, setIsAutopilotActive] = useState(false);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const abortControllerRef = useRef<AbortController | null>(null);
  const TrialEndAutoPilot = window.localStorage.getItem("TrialEndAutoPilot");
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const [open, setOpen] = useState(true);

  const handleOpenClose = () => {
    setOpen((open) => !open);
  };

  let requestURL = `https://dialogflow.cloud.google.com/v1/cx/locations/europe-west1/integrations/messenger/webhook/${process.env.REACT_APP_DIALOGFLOW_AGENT_ID}/sessions/${chatId}`;

  const classes = useStyles();

  const ref = useRef(null);

  const [state, setState] = useState<State>({
    textFieldValue: "",
  });

  const [listData, setListData] = useState(initialList);

  const messagesEndRef = useRef(document.createElement("div"));

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const [isWriting, setIsWriting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isWaitingForAI, setIsWaitingForAI] = useState(false);
  const [isQuantum, setIsQuantum] = useState(false);
  const [isQuantumClicked, setIsQuantumClicked] = useState(false);
  const [isQuantumSelected, setIsQuantumSelected] = useState(false);
  const [isBadRequest, setIsBadRequest] = useState(false);
  const [isAutopilotWriting, setIsAutopilotWriting] = useState(false);
  const [isAutopilotBusy, setIsAutopilotBusy] = useState(false);
  const [isGlitching, setIsGlitching] = useState(false);

  async function blowMyMind() {
    setIsBadRequest(true);
    await new Promise((r) => setTimeout(r, 3000));
    setIsBadRequest(false);
  }

  const commands = [
    {
      command: "send message",
      callback: () => handleAdd(),
    },
  ];
  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening,
  } = useSpeechRecognition({ commands });

  useEffect(() => {
    if (finalTranscript !== "") {
      setIsWriting((isWriting) => true);
      const newTextFieldValue = finalTranscript;
      setState({
        textFieldValue: newTextFieldValue,
      });
      resetTranscript();
    }
  }, [interimTranscript, finalTranscript]);
  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    console.log(
      "Your browser does not support speech recognition software! Try Chrome desktop, maybe?"
    );
    return null;
  }

  const listenContinuously = () => {
    SpeechRecognition.startListening({
      language: "en-GB",
    });
  };

  const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    setState({
      textFieldValue: e.target.value,
    });

    if (e.target.value !== "") {
      setIsWriting((isWriting) => true);
    } else {
      setIsWriting((isWriting) => false);
    }
  };

  const handleClickChatButton = (index: number, e: { currentTarget: any }) => {
    for (var key in e.currentTarget) {
      if (key.includes("Props")) {
        state.textFieldValue = e.currentTarget[key]["aria-valuetext"];
        handleAdd();
        break;
      }
    }
  };

  const handleClickChatLink = (url: string) => {
    window.open(url, "_blank", "noreferrer");
  };

  function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  async function glitchTheBot() {
    var glitchingTime = 3000;
    var shouldGlitch = false;
    while(glitchingTime > 0) {
      var timeToWait = getRandomInt(10, 100);
      shouldGlitch = !shouldGlitch;
      if (getRandomInt(0, 9) > 2 && shouldGlitch) {
        timeToWait += 100;
      }
      setIsGlitching(shouldGlitch);
      await new Promise((r) => setTimeout(r, timeToWait));
      glitchingTime -= timeToWait;
    }
    setIsGlitching(false);
  }

  async function counterReset() {
    while (true) {
      await new Promise((r) => setTimeout(r, 1000));

      if (timeToReset == -1) {
        continue;
      }

      while (timeToReset > 0) {
        await new Promise((r) => setTimeout(r, 1000));
        timeToReset -= 1;
      }

      setListData([
        {
          type: "text",
          content: [
            `Your conversation has been reset because 6 hours have passed since your last message. Say "Hi" again to start a new conversation.`,
          ],
          justify: "flex-start",
          visibility: "visible",
        },
      ]);

      timeToReset = -1;
    }
  }

  async function resetChat() {
    const newChatId = `dfMessenger-${Math.random().toString().slice(-8)}`;
    chatId = newChatId;
    requestURL = `https://dialogflow.cloud.google.com/v1/cx/locations/europe-west1/integrations/messenger/webhook/${process.env.REACT_APP_DIALOGFLOW_AGENT_ID}/sessions/${newChatId}`;
    dfMessenger?.setAttribute("session-id", newChatId);

    listData.push({
      type: "text",
      content: [
        `You decided to reset the conversation, so I'm going to deactivate now. Say "Hi" again to start a new conversation. Bye!`,
      ],
      justify: "flex-start",
      visibility: "visible",
    });
    setListData(listData);
    scrollToBottom();

    setIsLoading((isLoading) => true);
    await new Promise((r) => setTimeout(r, 20));
    scrollToBottom();

    await new Promise((r) => setTimeout(r, 4980));
    setListData([]);
    setIsLoading((isLoading) => false);

    setShowResume(false);
    props.setStartAutoPilot(false);
    setCurrentItemIndex(0);
  }

  function handleKeyPress(e: any) {
    if (
      e.keyCode === 13 &&
      0 < state.textFieldValue.length &&
      state.textFieldValue.length <= 256
    ) {
      handleAdd();
      setShowResume(false);
      props.setStartAutoPilot(false);
    }
  }

  async function writeWord(word: string, prevMessages: number) {
    setIsAutopilotBusy(true);
    let text = "";
    let lastMessages = listData.slice(prevMessages);
    let waitWeight = 0;
    for (const message of lastMessages) {
      for (const line of message.content) {
        waitWeight += line.length;
      }
    }
    let timeout = (-5.74 + Math.log(waitWeight) / Math.log(1.68)) * 1000;
    await new Promise((r) => setTimeout(r, timeout));
    setIsAutopilotWriting(true);
    for (const char of word) {
      text += char;
      setState((prevState) => ({ ...prevState, textFieldValue: text }));
      await new Promise((r) => setTimeout(r, 150));
    }
    state.textFieldValue = word;
    setState((prevState) => ({ ...prevState, textFieldValue: "" }));
    setIsAutopilotWriting(false);
    setIsAutopilotBusy(false);
  }

  useEffect(() => {
    if (props.startAutoPilot) {
      handleActivateAutopilot();
    }
  }, [props.startAutoPilot]);

  async function processItems(inputs: string[], signal: AbortSignal) {
    let prevMessages = 0;
    for (let i = currentItemIndex; i < inputs.length; i++) {
      if (signal.aborted) {
        setCurrentItemIndex(i); // Salva l'indice corrente
        break;
      }

      // Check for Bug Invasion minigame
      if (i > 0 && listData[listData.length - 3].type === "text" && listData[listData.length - 3].content[0] ===
        "My systems are detecting another invasion! Can you help me defeat those pesky bugs?"
      ) {
          await writeWord("Not this time, sorry.", prevMessages);
          await handleAdd();
        }

      await writeWord(inputs[i], prevMessages);
      prevMessages = listData.length;
      await handleAdd();

      // Controlla se siamo arrivati alla fine dell'array di input
      if (i === inputs.length - 1) {
        window.localStorage.setItem("TrialEndAutoPilot", "end");

        props.setStartAutoPilot(false); // Imposta startAutoPilot a false
      }
    }
  }

  const handleActivateAutopilot = () => {
    let inputs = [
      "Hi",
      "Resume",
      "Alessandro",
      "No",
      "Declarative",
      "Modernization",
      "gcp",
      "Conversationally",
      "I need the infrastructure for a web app",
      "Make Changes",
      "My web app is containerized, can you provide a better gcp service?",
      "My version",
      "Change provider",
      "multicloud",
      "give me the cheapest solution using just AWS and GCP",
      "Generate cost",
      "average",
      "no",
    ];

    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    setIsAutopilotActive(true);
    processItems(inputs, abortController.signal).then(() =>
      setIsAutopilotActive(false)
    );
    setIsWriting(false);
  };
  const handleStop = () => {
    setShowResume(true);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      setCurrentItemIndex(currentItemIndex); // Mantieni l'indice corrente per interrompere l'elaborazione
    }
  };
  const handleResume = () => {
    setShowResume(false);
    setCurrentItemIndex(0); // Resetta l'indice corrente
    handleActivateAutopilot();
  };

  const handleOpen = () => {
    props.setShowAutoPilot(true);
  };

  async function handleAdd() {
    var mustWaitCreate = false;
    var mustWaitEdit = false;
    var mustWaitProposal = false;
    var mustWaitChangeProvider = false;
    var mustWaitUpdate = false;
    var mustWaitUpdateTF = false;
    var mustGlitch = false;

    const userText = state.textFieldValue;
    state.textFieldValue = "";
    SpeechRecognition.stopListening();

    listData.forEach((listItem: any) => {
      if (listItem.type !== "text" && listItem.type !== "accordion") {
        listItem.visibility = "hidden";
      }
    });

    timeToReset = ttl;

    if (userText !== "") {
      listData.push({
        type: "text",
        content: [userText],
        justify: "flex-end",
        visibility: "visible",
      });
    }

    /*var newListData = listData;
    if (listData[listData.length - 1].content[0] === "WAIT_UPDATE") {
      newListData[listData.length - 1].content[0] =
        "Cost calculation completed. I'm writing the results in a file. Please wait a little more.";
    }*/

    setListData(listData);
    scrollToBottom();

    setIsLoading((isLoading) => true);
    await new Promise((r) => setTimeout(r, 20));
    scrollToBottom();

    try {
      const response = await fetch(requestURL, {
        method: "POST",
        body: JSON.stringify({
          queryInput: {
            text: { text: userText },
            languageCode: "en",
          },
          queryParams: {
            payload: { userId: uid, idToken: idToken },
            sessionTtl: `${ttl}s`,
          },
        }),
      });

      const data = await response.text();

      var responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
        .queryResult.responseMessages;

      //var newListDataAgent = newListDataUser;
      if (
        JSON.parse(data.replace(/^\)\]\}'\n/, "")).queryResult.text ===
        "Quantum Intelligence"
      ) {
        setIsQuantumClicked(true);
      }
      if (
        isQuantumClicked &&
        JSON.parse(data.replace(/^\)\]\}'\n/, "")).queryResult.text === "Yes"
      ) {
        setIsQuantumSelected(true);
      }

      if (responseMessages === undefined)
        responseMessages = [{ text: { text: ["WAIT_UPDATE"] } }];

      responseMessages.forEach((responseMessage: any) => {
        if ("text" in responseMessage) {
          if (responseMessage.text.text[0] == "WAIT_CREATE") {
            mustWaitCreate = true;
            setIsWaitingForAI(true);
          } else if (responseMessage.text.text[0] == "WAIT_EDIT") {
            mustWaitEdit = true;
            setIsWaitingForAI(true);
          } else if (responseMessage.text.text[0] == "WAIT_PROPOSAL") {
            mustWaitProposal = true;
            setIsWaitingForAI(true);
          } else if (responseMessage.text.text[0] == "WAIT_PROVIDER") {
            mustWaitChangeProvider = true;
            setIsWaitingForAI(true);
          } else if (responseMessage.text.text[0] == "WAIT_UPDATE") {
            mustWaitUpdate = true;
            if (isQuantumSelected) {
              setIsQuantumClicked(false);
              setIsQuantumSelected(false);
              setIsQuantum(true);
            }
            setIsWaitingForAI(true);
          } else if (responseMessage.text.text[0] == "WAIT_UPDATE_TF") {
            mustWaitUpdateTF = true;
            setIsWaitingForAI(true);
          } else {
            listData.push({
              type: "text",
              content: responseMessage.text.text[0].split("\n"),
              justify: "flex-start",
              visibility: "visible",
            });
            if (responseMessage.text.text[0] == "My systems are detecting another invasion! Can you help me defeat those pesky bugs?") {
              mustGlitch = true;
            }
          }
        } else if ("payload" in responseMessage) {
          var buttonsList: string[] = [];
          responseMessage.payload.richContent[0].forEach(
            (richContentElement: any) => {
              if ("options" in richContentElement) {
                richContentElement.options.forEach((button: any) => {
                  buttonsList = buttonsList.concat(button.text);
                });

                listData.push({
                  type: "buttons_text",
                  content: buttonsList,
                  justify: "flex-start",
                  visibility: "visible",
                });
              } else if ("dynamicOptions" in richContentElement) {
                richContentElement.dynamicOptions
                  .split(", ")
                  .forEach((button: any) => {
                    buttonsList = buttonsList.concat(button);
                  });

                listData.push({
                  type: "buttons_text",
                  content: buttonsList,
                  justify: "flex-start",
                  visibility: "visible",
                });
              } else if (
                "anchor" in richContentElement &&
                "text" in richContentElement
              ) {
                listData.push({
                  type: "button_link",
                  content: [richContentElement.text],
                  justify: "flex-start",
                  link: richContentElement.anchor.href,
                  visibility: "visible",
                });
              }
            }
          );
        }
      });

      setListData(listData);
      scrollToBottom();

      if (mustWaitCreate) {
        var longTaskResponse;
        var isBusy = true;
        await new Promise((r) => setTimeout(r, 20));
        scrollToBottom();
        while (isBusy) {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/check_create_thread/`,
            {
              method: "POST",
              body: JSON.stringify({
                sid: `${chatId}`,
              }),
            }
          );

          const data = await response.text();
          longTaskResponse = JSON.parse(data);

          isBusy = !longTaskResponse.response_ready;

          await new Promise((r) => setTimeout(r, 1000));
          scrollToBottom();
        }

        const backend_response = longTaskResponse.response;

        listData.push({
          type: "text",
          content: [backend_response],
          justify: "flex-start",
          visibility: "visible",
        });

        if (backend_response === responseBadRequest) {
          blowMyMind();
        }
        setIsWaitingForAI(false);
        setIsQuantum(false);

        var next_step;

        if (longTaskResponse.response_error) {
          next_step = "GOBACK";
        } else {
          next_step = "CONTINUE";
        }

        const response = await fetch(requestURL, {
          // UPDATE
          method: "POST",
          body: JSON.stringify({
            queryInput: {
              text: { text: next_step },
              languageCode: "en",
            },
            queryParams: {
              payload: { userId: uid, idToken: idToken },
            },
          }),
        });

        const data = await response.text();

        const responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
          .queryResult.responseMessages;

        if (responseMessages !== undefined) {
          responseMessages.forEach((responseMessage: any) => {
            if ("text" in responseMessage) {
              listData.push({
                type: "text",
                content: [responseMessage.text.text[0]],
                justify: "flex-start",
                visibility: "visible",
              });
            } else if ("payload" in responseMessage) {
              var buttonsList: string[] = [];
              responseMessage.payload.richContent[0].forEach(
                (richContentElement: any) => {
                  if ("options" in richContentElement) {
                    richContentElement.options.forEach((button: any) => {
                      buttonsList = buttonsList.concat(button.text);
                    });

                    listData.push({
                      type: "buttons_text",
                      content: buttonsList,
                      justify: "flex-start",
                      visibility: "visible",
                    });
                  } else if (
                    "anchor" in richContentElement &&
                    "text" in richContentElement
                  ) {
                    listData.push({
                      type: "button_link",
                      content: [richContentElement.text],
                      justify: "flex-start",
                      link: richContentElement.anchor.href,
                      visibility: "visible",
                    });
                  }
                }
              );
            }
          });
        }
      } else if (mustWaitEdit) {
        var longTaskResponse;
        var isBusy = true;
        await new Promise((r) => setTimeout(r, 20));
        scrollToBottom();
        while (isBusy) {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/check_edit_threads/`, // to be changed
            {
              method: "POST",
              body: JSON.stringify({
                sid: `${chatId}`,
              }),
            }
          );

          const data = await response.text();
          longTaskResponse = JSON.parse(data);

          isBusy = !(
            longTaskResponse.proposal.response_ready &&
            longTaskResponse.real.response_ready
          );

          await new Promise((r) => setTimeout(r, 1000));
          scrollToBottom();
        }

        const backend_response_real = longTaskResponse.real.response;

        if (backend_response_real === responseBadRequest) {
          blowMyMind();
        }
        setIsWaitingForAI(false);
        setIsQuantum(false);

        var next_step;
        var backend_response_proposal = "";

        if (longTaskResponse.real.response_error) {
          next_step = "GOBACK";
        } else if (longTaskResponse.proposal.response_error) {
          next_step = "CONTINUE_WITHOUT_PROPOSAL";
        } else {
          next_step = "CONTINUE";

          if (!longTaskResponse.proposal.response_error) {
            backend_response_proposal = `\n${longTaskResponse.proposal.response}`;
          }
        }

        listData.push({
          type: "text",
          content: [`${backend_response_real}${backend_response_proposal}`],
          justify: "flex-start",
          visibility: "visible",
        });

        const response = await fetch(requestURL, {
          // UPDATE
          method: "POST",
          body: JSON.stringify({
            queryInput: {
              text: { text: next_step },
              languageCode: "en",
            },
            queryParams: {
              payload: { userId: uid, idToken: idToken },
            },
          }),
        });

        const data = await response.text();

        const responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
          .queryResult.responseMessages;

        if (responseMessages !== undefined) {
          responseMessages.forEach((responseMessage: any) => {
            if ("text" in responseMessage) {
              listData.push({
                type: "text",
                content: [responseMessage.text.text[0]],
                justify: "flex-start",
                visibility: "visible",
              });
            } else if ("payload" in responseMessage) {
              var buttonsList: string[] = [];
              responseMessage.payload.richContent[0].forEach(
                (richContentElement: any) => {
                  if ("options" in richContentElement) {
                    richContentElement.options.forEach((button: any) => {
                      buttonsList = buttonsList.concat(button.text);
                    });

                    listData.push({
                      type: "buttons_text",
                      content: buttonsList,
                      justify: "flex-start",
                      visibility: "visible",
                    });
                  } else if (
                    "anchor" in richContentElement &&
                    "text" in richContentElement
                  ) {
                    listData.push({
                      type: "button_link",
                      content: [richContentElement.text],
                      justify: "flex-start",
                      link: richContentElement.anchor.href,
                      visibility: "visible",
                    });
                  }
                }
              );
            }
          });
        }
      } else if (mustWaitProposal) {
        var longTaskResponse;
        var isBusy = true;
        await new Promise((r) => setTimeout(r, 20));
        scrollToBottom();
        while (isBusy) {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/check_proposal_thread/`,
            {
              method: "POST",
              body: JSON.stringify({
                sid: `${chatId}`,
              }),
            }
          );

          const data = await response.text();
          longTaskResponse = JSON.parse(data);

          isBusy = !longTaskResponse.response_ready;

          await new Promise((r) => setTimeout(r, 1000));
          scrollToBottom();
        }

        const backend_response = longTaskResponse.response;

        listData.push({
          type: "text",
          content: [backend_response],
          justify: "flex-start",
          visibility: "visible",
        });

        if (backend_response === responseBadRequest) {
          blowMyMind();
        }
        setIsWaitingForAI(false);
        setIsQuantum(false);

        var next_step;

        if (longTaskResponse.response_error) {
          next_step = "CONTINUE";
        } else {
          next_step = "CONTINUE";
        }

        const response = await fetch(requestURL, {
          // UPDATE
          method: "POST",
          body: JSON.stringify({
            queryInput: {
              text: { text: next_step },
              languageCode: "en",
            },
            queryParams: {
              payload: { userId: uid, idToken: idToken },
            },
          }),
        });

        const data = await response.text();
        const responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
          .queryResult.responseMessages;

        if (responseMessages !== undefined) {
          responseMessages.forEach((responseMessage: any) => {
            if ("text" in responseMessage) {
              listData.push({
                type: "text",
                content: [responseMessage.text.text[0]],
                justify: "flex-start",
                visibility: "visible",
              });
            } else if ("payload" in responseMessage) {
              var buttonsList: string[] = [];
              responseMessage.payload.richContent[0].forEach(
                (richContentElement: any) => {
                  if ("options" in richContentElement) {
                    richContentElement.options.forEach((button: any) => {
                      buttonsList = buttonsList.concat(button.text);
                    });

                    listData.push({
                      type: "buttons_text",
                      content: buttonsList,
                      justify: "flex-start",
                      visibility: "visible",
                    });
                  } else if (
                    "anchor" in richContentElement &&
                    "text" in richContentElement
                  ) {
                    listData.push({
                      type: "button_link",
                      content: [richContentElement.text],
                      justify: "flex-start",
                      link: richContentElement.anchor.href,
                      visibility: "visible",
                    });
                  }
                }
              );
            }
          });
        }
      } else if (mustWaitChangeProvider) {
        var longTaskResponse;
        var isBusy = true;
        await new Promise((r) => setTimeout(r, 20));
        scrollToBottom();
        while (isBusy) {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/change_provider_thread/`,
            {
              method: "POST",
              body: JSON.stringify({
                sid: `${chatId}`,
              }),
            }
          );

          const data = await response.text();
          longTaskResponse = JSON.parse(data);

          isBusy = !longTaskResponse.response_ready;

          await new Promise((r) => setTimeout(r, 1000));
          scrollToBottom();
        }

        const backend_response = longTaskResponse.response;

        listData.push({
          type: "text",
          content: [backend_response],
          justify: "flex-start",
          visibility: "visible",
        });

        if ("response_accordion" in longTaskResponse) {
          const accordion = longTaskResponse.response_accordion;
          listData.push({
            type: "accordion",
            title: [accordion.title],
            subtitle: [accordion.subtitle],
            text: [accordion.text],
            justify: "flex-start",
            visibility: "visible",
          });
        }

        if (backend_response === responseBadRequest) {
          blowMyMind();
        }
        setIsWaitingForAI(false);
        setIsQuantum(false);

        var next_step;

        if (longTaskResponse.response_error) {
          next_step = "ERROR";
        } else {
          next_step = "CONTINUE";
        }

        const response = await fetch(requestURL, {
          // UPDATE
          method: "POST",
          body: JSON.stringify({
            queryInput: {
              text: { text: next_step },
              languageCode: "en",
            },
            queryParams: {
              payload: { userId: uid, idToken: idToken },
            },
          }),
        });

        const data = await response.text();
        const responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
          .queryResult.responseMessages;

        if (responseMessages !== undefined) {
          responseMessages.forEach((responseMessage: any) => {
            if ("text" in responseMessage) {
              listData.push({
                type: "text",
                content: [responseMessage.text.text[0]],
                justify: "flex-start",
                visibility: "visible",
              });
            } else if ("payload" in responseMessage) {
              var buttonsList: string[] = [];
              responseMessage.payload.richContent[0].forEach(
                (richContentElement: any) => {
                  if ("options" in richContentElement) {
                    richContentElement.options.forEach((button: any) => {
                      buttonsList = buttonsList.concat(button.text);
                    });

                    listData.push({
                      type: "buttons_text",
                      content: buttonsList,
                      justify: "flex-start",
                      visibility: "visible",
                    });
                  } else if (
                    "anchor" in richContentElement &&
                    "text" in richContentElement
                  ) {
                    listData.push({
                      type: "button_link",
                      content: [richContentElement.text],
                      justify: "flex-start",
                      link: richContentElement.anchor.href,
                      visibility: "visible",
                    });
                  }
                }
              );
            }
          });
        }
      } else if (mustWaitUpdate) {
        var longTaskResponse;
        var isBusy = true;
        await new Promise((r) => setTimeout(r, 20));
        scrollToBottom();
        while (isBusy) {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/update_cost_thread/`,
            {
              method: "POST",
              body: JSON.stringify({
                sid: `${chatId}`,
              }),
            }
          );

          const data = await response.text();
          longTaskResponse = JSON.parse(data);

          isBusy = !longTaskResponse.response_ready;

          await new Promise((r) => setTimeout(r, 1000));
          scrollToBottom();
        }

        const backend_response = longTaskResponse.response;
        setIsWaitingForAI(false);
        setIsQuantum(false);

        var next_step;

        if (longTaskResponse.response_error) {
          next_step = "GOBACK";
        } else {
          next_step = "CONTINUE";
        }

        const response = await fetch(requestURL, {
          // UPDATE
          method: "POST",
          body: JSON.stringify({
            queryInput: {
              text: { text: next_step },
              languageCode: "en",
            },
            queryParams: {
              payload: { userId: uid, idToken: idToken },
            },
          }),
        });

        const data = await response.text();

        const responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
          .queryResult.responseMessages;

        if (responseMessages !== undefined) {
          responseMessages.forEach((responseMessage: any) => {
            if ("text" in responseMessage) {
              if (responseMessage.text.text[0] !== "WAIT_UPDATE") {
                listData.push({
                  type: "text",
                  content: [responseMessage.text.text[0]],
                  justify: "flex-start",
                  visibility: "visible",
                });
              }
            } else if ("payload" in responseMessage) {
              var buttonsList: string[] = [];
              responseMessage.payload.richContent[0].forEach(
                (richContentElement: any) => {
                  if ("options" in richContentElement) {
                    richContentElement.options.forEach((button: any) => {
                      buttonsList = buttonsList.concat(button.text);
                    });

                    listData.push({
                      type: "buttons_text",
                      content: buttonsList,
                      justify: "flex-start",
                      visibility: "visible",
                    });
                  } else if (
                    "anchor" in richContentElement &&
                    "text" in richContentElement
                  ) {
                    listData.push({
                      type: "button_link",
                      content: [richContentElement.text],
                      justify: "flex-start",
                      link: richContentElement.anchor.href,
                      visibility: "visible",
                    });
                  }
                }
              );
            }
          });
        }
      } else if (mustWaitUpdateTF) {
        var longTaskResponse;
        var isBusy = true;
        await new Promise((r) => setTimeout(r, 20));
        scrollToBottom();
        while (isBusy) {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/update_cost_thread_tf/`,
            {
              method: "POST",
              body: JSON.stringify({
                sid: `${chatId}`,
              }),
            }
          );

          const data = await response.text();
          longTaskResponse = JSON.parse(data);

          isBusy = !longTaskResponse.response_ready;

          await new Promise((r) => setTimeout(r, 1000));
          scrollToBottom();
        }

        const backend_response = longTaskResponse.response;
        setIsWaitingForAI(false);
        setIsQuantum(false);

        var next_step;

        if (longTaskResponse.response_error) {
          next_step = "GOBACK";
        } else {
          next_step = "CONTINUE";
        }

        const response = await fetch(requestURL, {
          // UPDATE
          method: "POST",
          body: JSON.stringify({
            queryInput: {
              text: { text: next_step },
              languageCode: "en",
            },
            queryParams: {
              payload: { userId: uid, idToken: idToken },
            },
          }),
        });

        const data = await response.text();

        const responseMessages = JSON.parse(data.replace(/^\)\]\}'\n/, ""))
          .queryResult.responseMessages;

        if (responseMessages !== undefined) {
          responseMessages.forEach((responseMessage: any) => {
            if ("text" in responseMessage) {
              listData.push({
                type: "text",
                content: [responseMessage.text.text[0]],
                justify: "flex-start",
                visibility: "visible",
              });
            } else if ("payload" in responseMessage) {
              var buttonsList: string[] = [];
              responseMessage.payload.richContent[0].forEach(
                (richContentElement: any) => {
                  if ("options" in richContentElement) {
                    richContentElement.options.forEach((button: any) => {
                      buttonsList = buttonsList.concat(button.text);
                    });

                    listData.push({
                      type: "buttons_text",
                      content: buttonsList,
                      justify: "flex-start",
                      visibility: "visible",
                    });
                  } else if (
                    "anchor" in richContentElement &&
                    "text" in richContentElement
                  ) {
                    listData.push({
                      type: "button_link",
                      content: [richContentElement.text],
                      justify: "flex-start",
                      link: richContentElement.anchor.href,
                      visibility: "visible",
                    });
                  }
                }
              );
            }
          });
        }
      }
      setListData(listData);
      scrollToBottom();
    } catch (error) {
      console.error("Error:", error);
    }

    setIsLoading((isLoading) => false);
    setIsWriting((isWriting) => false);
    scrollToBottom();
    
    if (mustGlitch) {
      glitchTheBot();
    }
  }

  const StyledButton = withStyles({
    root: {
      textTransform: "none",
      backgroundColor: "#ffffff",
      borderColor: "primary",
      borderRadius: "20px",
      boxShadow: "0px 2px #cccccc",
      "&:hover": {
        backgroundColor: "#d6e1ff",
      },
    },
  })(Button);

  const sendEvent = (metricName: string) => {
    let uid = window.sessionStorage.getItem("uid");
    let sid = window.sessionStorage.getItem("chatId");
    if (typeof uid !== "string") {
      uid = "null";
    }

    gtag("config", "G-LBY0B19H81", {
      custom_map: {
        dimension1: "UserId",
        dimension2: "SessionId",
        metric1: metricName,
      },
    });

    gtag("event", "buttonClicked", {
      UserId: uid,
      SessionId: sid,
      [metricName]: 1,
    });
  };

  const uid =
    window.sessionStorage.getItem("uid") === null
      ? "JEVZyG7f36S8BPNE6kSTryos43t1"
      : window.sessionStorage.getItem("uid");
  const idToken = window.sessionStorage.getItem("idToken") ?? "no-Token";
  const [isHovered, setIsHovered] = useState(false);
  const [resetIsHovered, setResetIsHovered] = useState(false);

  useEffect(() => {
    counterReset();
  }, []);

  return (
    <div
      style={{
        width: windowSize[0] * 0.2,
        position: "absolute",
        bottom: props.bottom,
        right: props.right,
        zIndex: props.zIndex,
        pointerEvents: props.pointerEvents,
        opacity: props.opacity,
        display: props.display,
      }}
    >
      <MuiThemeProvider theme={theme}>
        <Stack direction="column-reverse">
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <div />
            {open ? (
              isBadRequest ? (
                <img
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  src={iconError}
                  onClick={() => {
                    handleOpenClose();
                    sendEvent("button_openclosechatbot");
                  }}
                />
              ) : isWaitingForAI && isQuantum ? (
                <img
                  alt="icon"
                  style={{ cursor: "pointer", marginLeft: "70%" }}
                  src={iconQuantum}
                  onClick={() => {
                    handleOpenClose();
                    sendEvent("button_openclosechatbot");
                  }}
                />
              ) : isWaitingForAI ? (
                <img
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  src={iconAI}
                  onClick={() => {
                    handleOpenClose();
                    sendEvent("button_openclosechatbot");
                  }}
                />
              ) : isLoading ? (
                <img
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  src={iconLoading}
                  onClick={() => {
                    handleOpenClose();
                    sendEvent("button_openclosechatbot");
                  }}
                />
              ) : isAutopilotActive ? (
                isAutopilotWriting ? (
                  <img
                    alt="icon"
                    style={{ cursor: "pointer" }}
                    src={iconAutopilotWriting}
                    onClick={() => {
                      handleOpenClose();
                      sendEvent("button_openclosechatbot");
                    }}
                  />
                ) : (
                  <img
                    alt="icon"
                    style={{ cursor: "pointer" }}
                    src={iconAutopilotStill}
                    onClick={() => {
                      handleOpenClose();
                      sendEvent("button_openclosechatbot");
                    }}
                  />
                )
              ) : isGlitching ? (
                <img
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  src={iconGlitch}
                  onClick={() => {
                    handleOpenClose();
                    sendEvent("button_openclosechatbot");
                  }}
                />
              ) : (
                <img
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  src={iconOpen}
                  onClick={() => {
                    handleOpenClose();
                    sendEvent("button_openclosechatbot");
                  }}
                />
              )
            ) : (
              <img
                alt="icon"
                style={{ cursor: "pointer" }}
                src={iconClosed}
                onClick={() => {
                  handleOpenClose();
                  sendEvent("button_openclosechatbot");
                }}
              />
            )}
            {/* <Fab
              size="medium"
              color="primary"
              aria-label="add"
              onClick={() => {
                handleOpenClose();
                sendEvent("button_openclosechatbot");
              }}
            >
              {open ? <Close /> : <Person />}
            </Fab> */}
          </Stack>
          <div style={{ height: open ? "10px" : "0px" }} />
          <Collapse
            in={open}
            timeout="auto"
            style={{ width: open ? "100%" : "0px" }}
          >
            <Grid
              container
              component={Paper}
              className={classes.chatSection}
              style={{ borderRadius: "10px" }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  backgroundColor: "#458aeb",
                }}
              >
                <Typography
                  color="#ffffff"
                  paddingTop="10px"
                  paddingBottom="10px"
                  paddingLeft="15px"
                  paddingRight="15px"
                  borderRadius="10px 10px 0 0"
                  style={{
                    fontSize: "18px",
                    marginTop: "-2px",
                  }}
                >
                  Nexbot
                </Typography>
                <Stack direction="row" spacing="0px">
                  <Button
                    variant="outlined"
                    style={{
                      opacity:
                        isAutopilotBusy || (props.startAutoPilot && !showResume)
                          ? "0.5"
                          : "1",
                      cursor:
                        isAutopilotBusy || (props.startAutoPilot && !showResume)
                          ? "not-allowed"
                          : "pointer",
                      pointerEvents:
                        isAutopilotBusy || (props.startAutoPilot && !showResume)
                          ? "none"
                          : "auto",
                      backgroundColor: resetIsHovered ? "#053982" : "#1464c4",
                      fontSize: "14px",
                      border: "2px solid",
                      marginRight: "5px",
                      borderRadius: "10px",
                      borderColor: "white",
                      color: "white",
                      textTransform: "none",
                      height: "fit-content",
                      alignSelf: "center",
                    }}
                    onMouseEnter={() => setResetIsHovered(true)}
                    onMouseLeave={() => setResetIsHovered(false)}
                    onClick={resetChat}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="outlined"
                    style={{
                      backgroundColor:
                        TrialEndAutoPilot === "end"
                          ? "#1464c4"
                          : !showResume && props.startAutoPilot && !isHovered
                          ? "orange"
                          : !showResume && props.startAutoPilot && isHovered
                          ? "orangered"
                          : isHovered
                          ? "#053982"
                          : "#1464c4",
                      // button is disabled if trial is over or if chat is not empty
                      opacity:
                        TrialEndAutoPilot === "end" ||
                        (!props.startAutoPilot && listData.length > 2)
                          ? "0.5"
                          : "1",
                      cursor:
                        TrialEndAutoPilot === "end" ||
                        (!props.startAutoPilot && listData.length > 2)
                          ? "not-allowed"
                          : "pointer",
                      pointerEvents:
                        TrialEndAutoPilot === "end" ||
                        (!props.startAutoPilot && listData.length > 2)
                          ? "none"
                          : "auto",
                      display: showResume ? "none" : "block",
                      fontSize: "14px",
                      border: "2px solid",
                      marginRight: "5px",
                      borderRadius: "10px",
                      borderColor: "white",
                      color: "white",
                      textTransform: "none",
                      height: "fit-content",
                      alignSelf: "center",
                    }}
                    disabled={!props.startAutoPilot && listData.length > 2}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={props.startAutoPilot ? handleStop : handleOpen}
                  >
                    {!props.startAutoPilot ? "AutoPilot" : "Pause"}
                  </Button>
                  {showResume && (
                    <Button
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      variant="outlined"
                      style={{
                        fontSize: "14px",
                        border: "2px solid",
                        marginRight: "5px",
                        borderRadius: "10px",
                        borderColor: "white",
                        color: "white",
                        textTransform: "none",
                        height: "fit-content",
                        alignSelf: "center",
                        backgroundColor: !isHovered
                          ? "forestgreen"
                          : "darkgreen",
                      }}
                      onClick={() => {
                        handleResume();
                      }}
                    >
                      Resume
                    </Button>
                  )}
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <List className={classes.messageArea}>
                  {listData.map((listItem, index) => (
                    <ListItem
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: listItem.justify,
                        visibility: listItem.visibility,
                        height: listItem.visibility === "hidden" ? "0px" : "",
                      }}
                    >
                      {listItem.type === "text" ? (
                        <Box
                          bgcolor={
                            listItem.justify.includes("end")
                              ? "#dddddd"
                              : "#ffffff"
                          }
                          ml={listItem.justify.includes("end") ? "15%" : "0%"}
                          mr={listItem.justify.includes("start") ? "15%" : "0%"}
                          paddingTop="2px"
                          paddingBottom="2px"
                          paddingLeft="15px"
                          paddingRight="15px"
                          borderRadius={5}
                          borderColor="#dddddd"
                          maxWidth={"95%"}
                          sx={{
                            borderStyle: "solid",
                            borderWidth: 1,
                          }}
                        >
                          <ListItemText
                            primary={
                              <div>
                                {listItem.content.map(
                                  (listItemLine: string, index: number) => {
                                    /*if (
                                      isQuantum &&
                                      listItemLine === "WAIT_UPDATE"
                                    ) {
                                      setIsQuantum(false);
                                      handleAdd();
                                    }
                                    if (listItemLine === "WAIT_UPDATE")
                                      return null;*/
                                    return (
                                      <div
                                        key={index}
                                        style={{ wordWrap: "break-word" }}
                                      >
                                        {listItemLine}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            }
                            primaryTypographyProps={{
                              style: { whiteSpace: "normal" },
                            }}
                          />
                        </Box>
                      ) : listItem.type === "buttons_text" ? (
                        <Stack direction="row" spacing="10px">
                          <div>
                            {listItem.content.map((contentButton: string) => (
                              <Button
                                variant="outlined"
                                disabled={isAutopilotActive}
                                aria-valuetext={contentButton}
                                className="chatButton"
                                onClick={(e) => {
                                  handleClickChatButton(index, e);
                                  setShowResume(false);
                                  props.setStartAutoPilot(false);
                                }}
                              >
                                {contentButton}
                              </Button>
                            ))}
                          </div>
                        </Stack>
                      ) : listItem.type === "button_link" ? (
                        <Button
                          variant="outlined"
                          aria-valuetext={listItem.content[0]}
                          disabled={isAutopilotActive}
                          className="chatLink"
                          onClick={() => handleClickChatLink(listItem.link)}
                        >
                          <ArrowForwardIosIcon
                            style={{ fontSize: "small", color: "#1464c4" }}
                          />
                          {listItem.content[0]}
                        </Button>
                      ) : listItem.type === "accordion" ? (
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            //id="panel1-header"
                          >
                            <Typography>{listItem.title}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>{listItem.text}</Typography>
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        <div />
                      )}
                    </ListItem>
                  ))}
                  <img
                    src={myLoader}
                    alt="my-gif"
                    style={{
                      height: isLoading ? "15%" : "0px",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                  />
                  <div ref={messagesEndRef} />
                </List>
                <Divider />
                <Grid container style={{ padding: "7px" }}>
                  <Grid
                    style={{ display: "flex", alignItems: "center" }}
                    item
                    xs={10}
                  >
                    <TextField
                      disabled={
                        isAutopilotActive ||
                        (listData.length > 0 &&
                          listData[listData.length - 1].type == "buttons_text")
                      }
                      variant="standard"
                      ref={ref}
                      size="small"
                      value={
                        listening && !isWriting
                          ? transcript
                          : state.textFieldValue
                      }
                      helperText={
                        state.textFieldValue.length >= 200
                          ? `${state.textFieldValue.length}/256`
                          : ""
                      }
                      onChange={handleTextFieldChange}
                      onKeyDown={handleKeyPress}
                      fullWidth
                      color="secondary"
                      placeholder="Ask Something..."
                      InputProps={{ disableUnderline: true }}
                      style={{ paddingLeft: "10px" }}
                      error={state.textFieldValue.length > 256}
                    />
                  </Grid>
                  <Grid xs={2} justifyContent="flex-end">
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "space-between" }}
                      minHeight="28px"
                    >
                      <div />
                      <IconButton
                        style={{
                          margin: "10px",
                          color: "#458AEB",
                        }}
                        disabled={
                          (listData.length > 0 &&
                            listData[listData.length - 1].type ===
                              "buttons_text") ||
                          state.textFieldValue.length > 256
                        }
                        aria-setsize={50}
                        aria-label="add"
                        onClick={
                          isWriting
                            ? () => {
                                handleAdd();
                                setShowResume(false);
                                props.setStartAutoPilot(false);
                              }
                            : listening
                            ? SpeechRecognition.stopListening
                            : listenContinuously
                        }
                      >
                        {isWriting ? (
                          <Send style={{ height: "24px" }} />
                        ) : listening ? (
                          <img src={audio} height="24px" width="24px" />
                        ) : (
                          <Mic style={{ height: "24px" }} />
                        )}
                      </IconButton>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Collapse>
        </Stack>
      </MuiThemeProvider>
    </div>
  );
};

export default ChatWidget;
